import React, { useCallback } from 'react';
import { SectionPanel } from 'ui';
import { SecondaryTextMode, TranslationsComponent } from 'app/components/translation';
import { MetroLineSection } from 'app/components/metro-line/metro-line-section';
import { ExternalUrlSectionType } from '../metroline/types';
import { languageValidationParameter, maxDescriptionLength, maxLongDescriptionLength } from '../constants';
import { ExternalUrlLanguageProps } from '../types';

export const ExternalUrlLanguage: React.FC<ExternalUrlLanguageProps> = ({
  language, longDescription, mainLanguage, languageOptions, showTranslations, validation, translation, section,
  getRef, switchTranslationsToggle, shouldRenderSection, changeLanguage, copyLanguageToAll,
  changeLongDescription, copyLongDescriptionToAll
}) => {

  const copyDescriptionToAll = useCallback(() => {
    copyLanguageToAll(mainLanguage, translation.copied_description_to_all);
  }, [mainLanguage, translation]);

  const copyLongDescription = useCallback(() => {
    copyLongDescriptionToAll(mainLanguage, translation?.copied_long_description_to_all);
  }, [mainLanguage, translation]);


  return <MetroLineSection<ExternalUrlSectionType>
    section={section}
    sectionType={ExternalUrlSectionType.Translations}
    getRef={getRef}
    shouldRenderSection={shouldRenderSection}>
    <div ref={getRef(ExternalUrlSectionType.Translations)}>
      <SectionPanel
        className="admin-paper-top-panel"
        componentId={ExternalUrlSectionType.Translations}
        validation={undefined}
        info={{ text: translation.descriptions_and_translations }}
        label={{ visible: true, text: translation.descriptions_and_translations }} />
      <TranslationsComponent
        primaryText={language}
        secondaryText={longDescription}
        primaryTextValueKey={languageValidationParameter}
        secondaryTextValueKey={undefined}
        primaryTextMaxLength={maxDescriptionLength}
        secondaryTextMaxLength={maxLongDescriptionLength}
        languageOptions={languageOptions}
        mainLanguage={mainLanguage}

        primaryTextLabel={translation?.description}
        copyPrimaryTextToAllLabel={translation?.copy_description_to_all}
        onPrimaryTextChange={changeLanguage}
        copyPrimaryTextToAllTranslations={copyDescriptionToAll}
        copySecondaryTextToAllTranslations={copyLongDescription}

        secondaryTextLabel={translation?.long_description}
        copySecondaryTextToAllLabel={translation?.copy_long_description_to_all}
        secondaryTextMode={SecondaryTextMode.normal}
        onSecondaryTextChange={changeLongDescription}

        translationsHeaderLabel={translation?.translations_header}
        switchTranslationsToggleLabel={translation?.show_translations}
        hasTranslationsToggled={showTranslations}
        switchTranslationsToggle={switchTranslationsToggle}
        readOnly={false}
        validation={validation?.language} />
    </div>
  </MetroLineSection>;
};
